module.exports = __webpack_public_path__ + "assets/img/returnBtn-2671afe3.png";